<ng-container>
  <div class="wrapper__form">
    <div
      class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
      <h2 class="wrapper__form__title h4-tipografia-govco mb-0">
        {{ proconText['tramite-sic-procon']['notificaciones'] }}
      </h2>
    </div>

    <p>
      {{ proconText['tramite-sic-procon']['notificaciones-direcciones'] }}
    </p>

    <div class="container mt-3">
      <div class="row bg-secondary text-white">
        <div class="col border text-center p-2">{{ comunText['email'] }}</div>
        <div class="col border text-center p-2">
          {{ proconText['tramite-sic-procon']['otra-direccion'] }}
        </div>
      </div>

      <form [formGroup]="demandantesForm!">
        <div formArrayName="demandantes">
          <!-- Recorrer el FormArray -->
          <div
            *ngFor="let demandante of demandantes.controls; let i = index"
            [formGroupName]="i"
            class="row">
            <div class="col border text-center p-2">
              <input
                id="correoDemandante-{{ i }}"
                formControlName="correo"
                type="text"
                class="form-control"
                readonly/>
              <div
                *ngIf="
                  demandante.get('correo')?.errors &&
                  (demandante.get('correo')?.touched ||
                    demandante.get('correo')?.dirty)
                ">
                <small
                  class="text-danger"
                  *ngIf="demandante.get('correo')?.errors?.['required']">
                  {{ comunText['correo-required'] }}
                </small>
                <small
                  class="text-danger"
                  *ngIf="demandante.get('correo')?.errors?.['pattern']">
                  {{ comunText['email-pattern'] }}
                </small>
              </div>
            </div>

            <div class="col border text-center p-2">
              <input
                id="direccionDemandante-{{ i }}"
                formControlName="direccion"
                type="text"
                class="form-control"
                readonly/>
              <div
                *ngIf="
                  demandante.get('direccion')?.errors &&
                  (demandante.get('direccion')?.touched ||
                    demandante.get('direccion')?.dirty)
                ">
                <small
                  class="text-danger"
                  *ngIf="demandante.get('direccion')?.errors?.['required']">
                  {{ comunText['direccion-notificacion-judicial-required'] }}
                </small>
                <small
                  class="text-danger"
                  *ngIf="demandante.get('direccion')?.errors?.['pattern']">
                  {{ comunText['direccion-notificacion-judicial-pattern'] }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <br /><br />
    <p>
      {{ proconText['tramite-sic-procon']['demandado-notificaciones'] }}
    </p>

    <div class="container mt-3">
      <div class="row bg-secondary text-white">
        <div class="col border text-center p-2">{{ comunText['email'] }}</div>
        <div class="col border text-center p-2">
          {{ proconText['tramite-sic-procon']['otra-direccion'] }}
        </div>
      </div>

      <form [formGroup]="demandadosForm!">
        <div formArrayName="demandados">
          <div
            *ngFor="let demandado of demandados.controls; let i = index"
            [formGroupName]="i"
            class="row">
            <div class="col border text-center p-2">
              <input
                id="correoDemandado-{{ i }}"
                formControlName="correo"
                type="text"
                class="form-control"
                readonly/>
              <div
                *ngIf="
                  demandado.get('correo')?.errors &&
                  (demandado.get('correo')?.touched ||
                    demandado.get('correo')?.dirty)
                ">
                <small
                  class="text-danger"
                  *ngIf="demandado.get('correo')?.errors?.['required']">
                  {{ comunText['correo-required'] }}
                </small>
                <small
                  class="text-danger"
                  *ngIf="demandado.get('correo')?.errors?.['pattern']">
                  {{ comunText['email-pattern'] }}
                </small>
              </div>
<!--              <p>-->
<!--                <strong>{{ 'notas-SIC.nota1' | translate }}</strong>-->
<!--                {{ 'notas-SIC.nota-1' | translate }}-->
<!--              </p>-->
            </div>

            <div class="col border text-center p-2">
              <input
                id="direccionDemandado-{{ i }}"
                formControlName="direccion"
                type="text"
                class="form-control"
                readonly/>
              <div
                *ngIf="
                  demandado.get('direccion')?.errors &&
                  (demandado.get('direccion')?.touched ||
                    demandado.get('direccion')?.dirty)
                ">
                <small
                  class="text-danger"
                  *ngIf="demandado.get('direccion')?.errors?.['required']">
                  {{ comunText['direccion-notificacion-judicial-required'] }}
                </small>
                <small
                  class="text-danger"
                  *ngIf="demandado.get('direccion')?.errors?.['pattern']">
                  {{ comunText['direccion-notificacion-judicial-pattern'] }}
                </small>
              </div>
<!--              <p>-->
<!--                <strong>{{ 'notas-SIC.nota2' | translate }}</strong>-->
<!--                {{ 'notas-SIC.nota-2' | translate }}-->
<!--              </p>-->
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="mt-3 p-3 border bg-light" *ngIf="demandantesForm?.valid && demandadosForm?.valid">
    <div class="alert alert-info">
      <p>
        <strong>{{ 'confirmacion_envio.titulo' | translate }}</strong>
        {{ 'confirmacion_envio.mensaje' | translate }}
      </p>
      <p class="fst-italic">
        {{ 'confirmacion_envio.nota' | translate }}
      </p>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="confirmacionEnvio"
        [(ngModel)]="confirmacionEnvio"
      />
      <label class="form-check-label" for="confirmacionEnvio">
        {{ 'confirmacion_envio.checkbox' | translate }}
      </label>
    </div>
  </div>

  <div *ngIf="confirmacionEnvio" class="border p-4 mt-4 bg-white shadow-sm rounded">
    <h5 class="wrapper__form__title mb-0">
      {{ 'copia_envio.desea_enviar_copia' | translate }}
    </h5>

    <p>
      {{ 'copia_envio.descripcion' | translate:{ correo: correoDemandado, nombre: nombreDemandado } }}
    </p>

    <div class="d-flex gap-2 mt-3">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="rechazarEnvio()"
        aria-label="Rechazar envío">
        {{ 'copia_envio.rechazar' | translate }}
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="aceptarEnvio()"
        aria-label="Aceptar envío">
        {{ 'copia_envio.aceptar' | translate }}
      </button>
    </div>


  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="anterior()"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        aria-label="Atrás">
        {{ proconText['botones-envio']['atras'] }}
      </button>
      <div class="flex-row d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-govco fill-btn-govco w-auto"
          (click)="continuar($event, 1)"
          aria-label="Guardar sin enviar">
          {{ proconText['botones-envio']['guardar-sin-enviar'] }}
        </button>

        <button
          type="submit"
          class="btn-govco fill-send-govco w-auto"
          (click)="validarAntesDeContinuar($event, 2)"
          aria-label="Enviar">
          {{ proconText['botones-envio']['enviar'] }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
